import { toast } from "react-toastify";

export const sellBoostFetch = async (
	method,
	slug,
	data,
	avoidAlerts = false
) => {
	try {
		let response;
		let url = process.env.REACT_APP_BACKEND_DOMAIN;
		const token = localStorage.getItem("SellBoostToken");

		let headers = {};

		if (token) {
			headers["Authorization"] = `Bearer ${token}`;
		}

		if (
			!process.env.REACT_APP_ENVIRONMENT === undefined ||
			process.env.REACT_APP_ENVIRONMENT === null
		) {
			console.error("No environment set");
			return;
		}
		if (method === "GET") {
			response = await fetch(url + slug, {
				headers: headers,
				credentials: "include",
			});
		} else if (method === "POST" || method === "PUT") {
			headers["Content-Type"] = "application/json";
			response = await fetch(url + slug, {
				method: method,
				credentials: "include",
				headers: headers,
				body: JSON.stringify(data),
			});
		} else {
			console.error("Invalid method");
		}
		if (!response.ok) {
			if (response.status === 401 || response.status === 403) {
				window.location.replace("/login");
				localStorage.clear();
				return;
			} else if (response.status === 402) {
				const body = await response.json();
				console.log(body);
				const message = `${body.message}`;
				toast.error(message);
				setTimeout(() => {
					if (!window.location.href.includes("/onboarding")) {
						window.location.replace("/settings?tab=billing");
					}
				}, 4000);
				throw message;
			} else if (response.status === 491) {
				if (window.location.href.includes("/onboarding")) {
					window.location.replace("/");
				}
			} else if (response.status > 301) {
				const body = await response.json();
				const message = `An error occurred: ${body.msg}`;
				toast.error(message);
				throw message;
			}
		} else {
			try {
				const body = await response.json();
				return body;
			} catch (err) {
				console.log(err.message);
			}
		}
	} catch (err) {
		console.error(err);
	}
};
